export function isTraceBoardItemEqual(a, b) {
    return a === b || (a.id === b.id && a.columnId === b.columnId);
}
//# sourceMappingURL=isTraceBoardItemEqual.js.map